import React, { FC } from 'react';
import { QnadaReviewModeTabs, QuestionState } from '../../../../../constans/question-enums';
import { TReviewModeAdditionalAction } from '../questions-review-mode-container';
import { Droppable } from 'react-beautiful-dnd';
import { useStore } from '../../../../../store/store-provider';
import ActionButton from '../../../../shared/action-button/action-button';
import { TUpdateQuestion } from '../../../../../store/question-store/question-store';
import QuestionActionForm from '../../question-action-form/question-action-form';
import { observer } from 'mobx-react';
import QuestionEntity from '../../../../../store/question-store/question-entetiy';
import { DraggableQuestionWrapper } from '../../question-card-container/dragable-question-wrapper';


interface IProps {
    title: QnadaReviewModeTabs;
    questions: QuestionEntity[];
    updateQuestion: TUpdateQuestion;
    isDisabled: boolean;
    emptyQuestionsMsg?: string;
    reviewModeAdditionalAction?: TReviewModeAdditionalAction;
    isEmptyMsg?: number;
    droppableId: QuestionState;
    isSpecialActionButton?: boolean;
    numberOfNewQuestions?: number;
}


const QuestionsReviewModeTabContainer: FC<IProps> = observer(({
  title,
  questions,
  updateQuestion,
  isDisabled,
  reviewModeAdditionalAction,
  isEmptyMsg,
  droppableId,
  isSpecialActionButton,
  numberOfNewQuestions
}): JSX.Element => {

  const { questionStore } = useStore();
  const {
    isShowCreateQuestion,
    setShowCreateQuestion,
    editableQuestionId,
    setEditableQuestionState,
  } = questionStore;

  return (
    <>
      <div className="question-title-list">
        <h4>
          {title}
          <span>({questions.length})</span>
          {!!numberOfNewQuestions && (
            <span id="new-question-label-wrapper">
              { numberOfNewQuestions }<span>New</span>
            </span>
          )}
          {title === QnadaReviewModeTabs.FOR_REVIEW &&
            <span
              className="create-question"
              data-disabled={isShowCreateQuestion}
              onClick={() => setShowCreateQuestion(true)}
            >
              Create Question
            </span>}
        </h4>
        {(droppableId === 'PRIORITIZED' && questions.length > 0) &&
          <ActionButton
            customClasses="next-icon send-all theme-blue"
            onClick={() =>
              questionStore.updateBatchQuestionsCall(QuestionState.PRIORITIZED, QuestionState.PRESENTER)}
          >
            Send All
          </ActionButton>
        }
      </div>
      {title === QnadaReviewModeTabs.FOR_REVIEW && isShowCreateQuestion &&
        <QuestionActionForm setEditableQuestionState={setEditableQuestionState}/>}
      <Droppable droppableId={droppableId}>
        {(provided => (
          <div className="list-items" ref={provided.innerRef}>
            <ul className="unanswered-questions">
              {
                questions.map((question, index) => (
                  <DraggableQuestionWrapper
                    key={question.messageId}
                    question={question}
                    index={index}
                    reviewModeAdditionalAction={reviewModeAdditionalAction}
                    updateQuestion={updateQuestion}
                    isDisabled={isDisabled}
                    isSpecialActionButton={isSpecialActionButton}
                    editableQuestionId={editableQuestionId}
                    setEditableQuestionState={setEditableQuestionState}
                  />

                ))
              }
              {title === QnadaReviewModeTabs.FOR_REVIEW && !isEmptyMsg &&
                <p className="question-empty-msg">There are no unanswered questions.</p>}
              {provided.placeholder}
            </ul>
          </div>
        ))}
      </Droppable>
    </>
  );
});

export default QuestionsReviewModeTabContainer;
